import { useQuery } from "react-query";
import EventsApiClient from "api/EventsApiClient.js";

export function useFederationEvents(federationId, payload, options) {
    return useQuery(
        ["event", "federation", Number(federationId), payload],
        () => EventsApiClient.getFederationEvents(federationId, payload),
        options,
    );
}
